const fmt = {
  currency: (v) =>
    `R${Number(v).toLocaleString("en-ZA", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`,
  number: (n) => new Intl.NumberFormat("en-US").format(n),
  number: (n) => new Intl.NumberFormat("en-ZA").format(n),
  date: (s) =>
    s
      ? new Date(s).toLocaleDateString("en-ZA", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })
      : "—",
  pct: (n) => `${n}%`,
};

const STATUS_COLORS = {
  Active: "#22c55e",
  Delivered: "#22c55e",
  Collected: "#22c55e",
  Sufficient: "#22c55e",
  Good: "#22c55e",
  Pending: "#f59e0b",
  Processing: "#f59e0b",
  Partial: "#f59e0b",
  Warning: "#f59e0b",
  Confirmed: "#3b82f6",
  Scheduled: "#3b82f6",
  "In Transit": "#06b6d4",
  Unassigned: "#8b5cf6",
  Overdue: "#ef4444",
  Cancelled: "#6b7280",
  Critical: "#ef4444",
  Low: "#f59e0b",
  Blocked: "#ef4444",
};

const statusColor = (s) => STATUS_COLORS[s] || "#6b7280";

// ── User Data Utilities ────────────────────────────────────────────────────
const userUtils = {
  /**
   * Get the complete user object from storage
   * @returns {Object} User object or empty object if not found
   */
  getUser: () => {
    try {
      const userStr =
        localStorage.getItem("user") || sessionStorage.getItem("user");
      return userStr ? JSON.parse(userStr) : {};
    } catch (e) {
      return {};
    }
  },

  /**
   * Get user's organization ID
   * @returns {number|null} Organization ID or null if not set
   */
  getOrganizationId: () => {
    const user = userUtils.getUser();
    const orgFromUser =
      user.organization_id ||
      (user.organization && user.organization.organization_id) ||
      user.organizationId ||
      null;
    if (orgFromUser != null) return orgFromUser;
    const orgId = sessionStorage.getItem("organizationId");
    return orgId ? Number(orgId) : null;
  },

  /**
   * Get user's branch ID
   * @returns {number|null} Branch ID or null if not set
   */
  getBranchId: () => {
    const user = userUtils.getUser();
    const branchFromUser = user.branch_id || user.branchId || null;
    if (branchFromUser != null) return branchFromUser;
    const branchId = sessionStorage.getItem("branchId");
    return branchId ? Number(branchId) : null;
  },

  /**
   * Get user's warehouse ID
   * @returns {number|null} Warehouse ID or null if not set
   */
  getWarehouseId: () => {
    const user = userUtils.getUser();
    const warehouseFromUser = user.warehouse_id || user.warehouseId || null;
    if (warehouseFromUser != null) return warehouseFromUser;
    const warehouseId = sessionStorage.getItem("warehouseId");
    return warehouseId ? Number(warehouseId) : null;
  },

  /**
   * Get user's ID
   * @returns {string|number|null} User ID or null if not found
   */
  getUserId: () => {
    const user = userUtils.getUser();
    return user.id || sessionStorage.getItem("userId") || null;
  },

  /**
   * Get user's email
   * @returns {string} User email or empty string
   */
  getEmail: () => {
    const user = userUtils.getUser();
    return user.email || sessionStorage.getItem("userEmail") || "";
  },

  /**
   * Get user's name
   * @returns {string} User name or empty string
   */
  getName: () => {
    const user = userUtils.getUser();
    return user.name || sessionStorage.getItem("userName") || "";
  },

  /**
   * Get user's role
   * @returns {string} User role or empty string
   */
  getRole: () => {
    const user = userUtils.getUser();
    return user.role || sessionStorage.getItem("userRole") || "";
  },

  /**
   * Check if user is logged in
   * @returns {boolean} True if user is logged in
   */
  isLoggedIn: () => {
    return (
      sessionStorage.getItem("isLoggedIn") === "true" &&
      !!localStorage.getItem("token")
    );
  },

  /**
   * Clear all user data (logout)
   */
  clearUser: () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("userEmail");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("userGroup");
    sessionStorage.removeItem("organizationId");
    sessionStorage.removeItem("branchId");
    sessionStorage.removeItem("warehouseId");
    sessionStorage.removeItem("isLoggedIn");
  },
};

export { fmt, statusColor, userUtils };
